import React from "react";
import { ShoppingBag } from "lucide-react";
import { useStore } from "@/store/StoreContext";

export default function Navbar() {
  const { cartCount, setCartOpen, content } = useStore();

  return (
    <header
      data-testid="navbar"
      className="relative z-50 bg-transparent py-3.5"
    >
      <div className="mx-auto flex max-w-7xl items-center px-5 sm:px-8">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={content?.logo || "/assets/brand/logo.png"} alt="Rudralife" className="h-9 w-auto" />
        </a>
        <div className="ml-auto flex items-center gap-7 lg:gap-10">
          <nav className="hidden items-center gap-8 text-xs font-semibold uppercase tracking-[0.22em] text-[#3A2410] lg:flex">
            <a data-testid="nav-collection" href="#collection" className="transition-opacity duration-300 hover:opacity-60">Collection</a>
            <a data-testid="nav-anniversary" href="#anniversary" className="transition-opacity duration-300 hover:opacity-60">25 Years</a>
            <a data-testid="nav-topselling" href="#top-selling" className="transition-opacity duration-300 hover:opacity-60">Top Selling</a>
            <a data-testid="nav-celebrities" href="#celebrities" className="transition-opacity duration-300 hover:opacity-60">Patrons</a>
          </nav>
          <button
            data-testid="cart-button"
            onClick={() => setCartOpen(true)}
            className="relative flex h-10 w-10 items-center justify-center rounded-full bg-[#D4AF37] text-[#1C130B] shadow-[0_6px_20px_-4px_rgba(0,0,0,0.3)] transition-colors duration-300 hover:bg-[#8F6E1D] hover:text-white"
            aria-label="Open cart"
          >
            <ShoppingBag className="h-4.5 w-4.5" />
            {cartCount > 0 && (
              <span data-testid="cart-count" className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#B34A00] px-1 text-[10px] font-bold text-white">
                {cartCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
